import React from 'react';
import { Notification } from "@progress/kendo-react-notification";
interface TooManyRecordsBannerProps {
    recordCount: number;
}

const TooManyRecordsBanner: React.FC<TooManyRecordsBannerProps> = ({ recordCount }) => {
    if (recordCount <= 100) {
        return null;
    }

    return (
        <Notification key='1'
            type={{
                style: "info",
                icon: true,
            }}
            style={{ color: 'black', border: 'none', boxShadow: 'none', borderRadius: '0px', padding: '8px', width: '100%', textAlign: 'left', fontSize: '13px', verticalAlign: 'top' }}
            closable={false}>
            Only showing the last 100 records.
        </Notification>
    );
};

export default TooManyRecordsBanner;